var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48646",
    "data-name": "Group 48646",
    transform: "translate(-1191 -675)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138035",
    "data-name": "Rectangle 138035",
    width: 24,
    height: 24,
    transform: "translate(1191 675)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48648",
    "data-name": "Group 48648",
    transform: "translate(1192 676.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44601",
    "data-name": "Group 44601",
    transform: "translate(1 0.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_63945",
    "data-name": "Rectangle 63945",
    transform: "translate(0 4.451)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.917,
    height: 15.549,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.417,
    height: 14.049,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_89230",
    "data-name": "Path 89230",
    transform: "translate(-9.038 -2)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.992,8.025H14V5.615C14,3.618,15.342,2,17,2h4c1.656,0,3,1.618,3,3.615Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.49212265014648 6.52481746673584 L 22.49212265014648 5.614887237548828 C 22.49212265014648 4.468497276306152 21.80628395080566 3.49999737739563 20.99448394775391 3.49999737739563 L 16.99763298034668 3.49999737739563 C 16.18583297729492 3.49999737739563 15.50000286102295 4.468497276306152 15.50000286102295 5.614887237548828 L 15.50000286102295 6.52481746673584 L 22.49212265014648 6.52481746673584 M 23.99212265014648 8.02481746673584 L 14.00000286102295 8.02481746673584 L 14.00000286102295 5.614887237548828 C 14.00000286102295 3.618267297744751 15.34194278717041 1.99999725818634 16.99763298034668 1.99999725818634 L 20.99448394775391 1.99999725818634 C 22.65018272399902 1.99999725818634 23.99212265014648 3.618267297744751 23.99212265014648 5.614887237548828 L 23.99212265014648 8.02481746673584 Z",
    stroke: "none",
    fill: "#44546f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89231",
    "data-name": "Path 89231",
    d: "M19.3,22l-7.038,3.381a3.653,3.653,0,0,1-3.225,0L2,22",
    transform: "translate(-0.551 -12.411)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPort);
export default __webpack_public_path__ + "static/media/job-port.44eed0724037a0755e5b83c37680764e.svg";
export { ForwardRef as ReactComponent };